import { ReactNode } from 'react'

interface INotAvailableProps {
  children?: ReactNode
}

export const NotAvailable = ({ children }: INotAvailableProps) => (
  <div className={'flex flex-1 items-center justify-center gap-[4px] py-[32px]'}>
    <p>N/A</p>
    {children}
  </div>
)
